import type { IgnoredPages } from '@/modules/tools/bankruptcy/stores/types'

export const IgnoredPagesReport = ({
  ignoredPages,
}: {
  ignoredPages: IgnoredPages
}) => {
  const { skippedForms, otherPages } = ignoredPages
  const hasOther = otherPages.pages.length > 0

  if (skippedForms.length === 0 && !hasOther) {
    return (
      <p className="text-muted-foreground text-sm">
        Every page was read as part of a scored form.
      </p>
    )
  }

  return (
    <ul className="space-y-1.5 text-sm">
      {skippedForms.map((form) => (
        <li key={form.form} className="flex justify-between gap-4">
          <span className="text-muted-foreground">
            Form {form.form}, not scored
          </span>
          <span className="tabular-nums">pages {form.label}</span>
        </li>
      ))}
      {hasOther && (
        <li className="flex justify-between gap-4">
          <span className="text-muted-foreground">Not a scored form</span>
          <span className="tabular-nums">pages {otherPages.label}</span>
        </li>
      )}
    </ul>
  )
}
